<template>
  <div class="w100 cpfa">
    <div class="flexslider">
      <ul class="slides">
        <div
          class="lunBotu"
          :style="{ background: 'url(' + require('@/assets/' + Product['background']) + ')' }"
        >
          <div class="container">
            <div class="ban2 float clearfix">
              <!-- 产品名称 -->
              <div class="product">
                <div v-for="(item, index) in Product['h2']" :key="index" class="product-h2">{{item}}</div>
                <!-- <div v-for="(item, index) in Product['h3']" :key="index" class="product-h3">{{item}}</div> -->
                <div class="desc">
                  <p v-for="(item, index) in Product['desc']" :key="index">{{item}}</p>
                </div>
                <div class="product-p">
                  <p v-for="(item, index) in Product['p']" :key="index">{{item}}</p>
                </div>
                <!-- 版权标志 -->
                <span class="reg">&reg;</span>
                <!-- 产品 -->
                <div
                  class="brand"
                  :style="{ background: 'url(' + require('@/assets/' + Product['product']) + ') no-repeat ' }"
                ></div>
              </div>

              <div class="caiye">
                <div @click="getCooperate">商务合作</div>
                <!-- <div @click="gotodownload">下载产品介绍</div> -->
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="为了更好地为您服务，请首先填写商务合作申请，谢谢"
                  placement="top"
                >
                  <div class="gotodownload" @click="gotodownload">下载产品介绍</div>
                </el-tooltip>
              </div>
            </div>
            <!-- 配图 -->
            <img class="banner" :src="require('@/assets/' + Product['img'])" />
          </div>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Banner',
  props: {
    Product: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
    }
  },
  methods: {
    // 跳转到商业合作的位置
    getCooperate () {
      document.getElementById('submit').scrollIntoView()
    },
    // 跳转到下载文件的位置
    gotodownload () {
      document.getElementById('download').scrollIntoView()
    }
  }
}
</script>

<style scoped>
.flexslider {
  position: relative;
  height: 584px;
  overflow: hidden;
  z-index: 1;
  clear: both;
  margin-top: -65px;
}
.container {
  width: 997px;
  padding-top: 147px;
  min-width: 997px;
}

.cpfa .container .float {
  width: 56%;
  margin-top: 18px;
}
.cpfa .container .cpxl {
  float: left;
  margin-top: 49px;
  margin-left: 0px;
}
.banner {
  width: 42%;
}
.cpfa .container img {
  max-width: 560px;
  margin-top: 30px;
}
/* 产品 */
.product {
  background: rgba(248, 248, 248, 0);
 
}
.brand {
  width: 33px;
  height: 33px;
  margin-left: 0px;
  margin-top: -41px;
  background-size: contain !important;
}
/* 商标符号 */
.reg {
  font-size: 9px;
  margin-left: 34px;
  float: left;
  display: block;
  margin-top: -51px;
  color: rgba(153, 152, 152, 1);
}
.desc {
  margin-top: 35px;
  font-size: 32px;
  font-weight: normal;
  color: rgba(255, 255, 255, 1);
  /* float: left; */
}
.desc p {
  text-align: left;
  line-height: 41px;
  display: block;
  width: 730px;
  /* width: 100%; */
  float: left;
}
.product-h2 {
  margin-top: -95px;
  text-align: left;
  font-size: 56px;
  font-weight: normal;
  color: rgba(255, 255, 255, 1);
  width: 730px;
  /* width: 100%; */
  /* float: left; */
}
.product-p {
  left: 0px;
  top: 0px;
  font-size: 16px;
  font-weight: bold;
  color: rgba(153, 152, 152, 1);
  margin-top: 50px;
}
.product-p :first-child {
  margin-left: 44px;
}

.product-p p {
  text-align: left;
}

/* 下再彩页按钮 */
/* 下再彩页按钮 */
.caiye {
  /* border: px; */
  float: left;
  margin-top: 25px;
}
.caiye :first-child {
  width: 160px;
  line-height: 50px;
  background: linear-gradient(
    86deg,
    rgba(116, 96, 238, 1) 0%,
    rgba(252, 72, 122, 1) 100%
  );
  border-radius: 4px;
  font-size: 20px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  display: inline-block;
  filter: "progid:DXImageTransform.Microsoft.gradient(GradientType=1, startColorstr=rgba(116, 96, 238, 1), endColorstr=rgba(252, 72, 122, 1))";
  -ms-filter: "progid:DXImageTransform.Microsoft.gradient (GradientType=1, startColorstr=#7460EE, endColorstr=#FC487A)";
}
.gotodownload {
  margin-left: 15px;
  width: 158px;
  line-height: 47px;
  border: 1px solid rgba(255, 255, 255, 1);
  border-radius: 4px;
  font-size: 20px;
  color: rgba(255, 255, 255, 1);
  display: inline-block;
  margin-top: 1px;
  float: none;
}
.container /deep/ .el-button {
  background: rgba(0, 0, 0, 0.2);
}
.container /deep/ .el-button:hover {
  background: rgba(0, 0, 0, 0);
}
.lunBotu {
  margin-top: 4px;
  z-index: 1;
  background-size: 100% 100%;
  height: 587px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/productBanner.vue